<div class="app__mobile-page services-mobile" *ngIf="isMobile">
    <app-mobile-feed-page-template
        [count-of-pages]="countOfPages"
        [loaded-pages]="loadedPages"
        [is-loading]="loadingMoreContent"
        [root-url]="'home/services'"
        [view-page]="viewPage"
        [pages]="servicesPages"
        [no-more-content-text]="'Услуг больше нет.'"
        [is-feed-empty]="servicesPages.length === 0"
        [feed-empty-text]="'Услуг за выбранный период нет'"
        (load-next-page)="loadNextPage()"
        *ngIf="!isLoading; else pageLoader"
    >
        <feed-header-period
            header
            [periodText]="periodText"
            (onClick)="showPeriodDialog()"
            [canBeClear]="periodText != 'Платежи за всё время'"
            (onClear)="btnFilterByDay(null, null)"
        ></feed-header-period>

        <section
            page
            [id]="'page' + (pageIndex + 1)"
            class="services-mobile__page"
            *ngFor="let servicesPage of servicesPages; let pageIndex = index"
        >
            <!-- [is-hidden]="pageIndex === 0" -->
            <app-feed-page-anchor
                class="finance-page--anchor"
                (intersected)="viewPage = pageIndex + 1"
            >
                Страница {{ pageIndex + 1 }} из {{ countOfPages }}
            </app-feed-page-anchor>

            <section
                class="card"
                *ngFor="let serv of servicesPage; let i = index"
                (click)="showDetailsDialog(serv)"
            >
                <div class="card__head">
                    <span class="card__day">{{
                        getNameDay(serv.dtSort) | titlecase
                    }}</span>
                    <span class="card__date"
                        >{{ getDayWithYear(serv.dtSort) }} в
                        {{ getTime(serv.dtSort) }}</span
                    >
                </div>

                <div class="card__body">
                    <div class="card__content">
                        {{
                            serv.specName
                                ? serv.specName
                                : 'Специалист отсутствует'
                        }}
                    </div>
                </div>

                <div class="card__footer">
                    {{
                        serv.psPrice
                            ? (serv.psPrice | priceSpace : '.2') + ' руб'
                            : 'Бесплатно'
                    }}
                </div>
            </section>
        </section>

        <div fab class="calendar-btn" (click)="showPeriodDialog()">
            <mat-icon
                svgIcon="calendar"
                style="width: 64px; height: 64px"
            ></mat-icon>
        </div>
    </app-mobile-feed-page-template>
</div>

<ng-template #pageLoader>
    <div class="loader">
        <loader
            type="page"
            [isFullscreen]="true"
            message="Загружаем список услуг..."
        >
        </loader>
    </div>
</ng-template>

<div class="services-pc">
    <!-- <div class="services-pc__header"> -->
    <!-- <span class="services-pc__header-text">Услуги</span> -->
    <!-- *ngIf="!isMobile" -->
    <div class="header">
        <div class="header__buttons">
            <h2 class="header__title">Услуги</h2>
            <button
                class="header__buttons-button"
                (click)="btnFilterTekPC()"
                [class.selected]="selectedButton === 'today'"
                [disabled]="isLoading || selectedButton === 'today'"
            >
                за сегодня
            </button>
            <button
                class="header__buttons-button"
                (click)="btnFilter3DayPC()"
                [class.selected]="selectedButton === '3days'"
                [disabled]="isLoading || selectedButton === '3days'"
            >
                за 3 дня
            </button>
            <button
                class="header__buttons-button"
                (click)="btnAllDays()"
                [class.selected]="selectedButton === 'all'"
                [disabled]="
                    isLoading ||
                    (selectedButton === 'all' && !customDateSelected)
                "
            >
                Все
            </button>
        </div>
        <div
            class="payments-page__date-range"
            [class.highlighted]="customDateSelected"
        >
            <app-date-range
                [dtBegin]="dtBegin"
                [dtEnd]="dtEnd"
                (onChanged)="onDateRangeChanged($event)"
            ></app-date-range>
        </div>
    </div>

    <div class="loader-container" *ngIf="isLoading">
        <loader type="page" message="Загружаем список услуг..."> </loader>
    </div>
    

    <div class="services-pc__body" *ngIf="!isLoading">
        <div *ngIf="servicesListLength === 0">
            <div class="cls-not-rec">Услуг за выбранный период нет</div>
        </div>        
        
        <div *ngIf="servicesListLength > 0">
            <div class="service-table" #servicesContainer>
                <ng-container
                    *ngFor="
                        let serv of servicesList;
                        let i = index;
                        trackBy: trackById
                    "
                    class="service__rows"
                >
                    <span
                        class="service-table__block-year"
                        *ngIf="isBlockYearPC(i)"
                    >
                        {{ getYearPC(i) }}
                    </span>

                    <div class="service-table__row">
                        <div class="service-table__text-date">
                            <div class="service-table__text-date-container">
                                <span
                                    class="service-table__text-date-container-day"
                                >
                                    {{ getTekDayPC(serv.dtSort) }} в&nbsp;
                                </span>
                                <span
                                    class="service-table__text-date-container-time"
                                >
                                    {{ getTimePC(serv.dtSort) }}
                                </span>
                            </div>
                            <span class="service-table__text-date-name">
                                {{ getNameDayPC(serv.dtSort) }}
                            </span>
                        </div>
                        <span class="service-table__name service-table__text">
                            {{ serv.sdName }}
                        </span>
                        <span class="service-table__place service-table__text">
                            {{ serv.place }}
                        </span>
                        <span class="service-table__price service-table__text">
                            {{ serv.psPrice | priceSpace : ".2" }} руб
                        </span>
                        <span class="service-table__spec service-table__text">
                            {{ serv.specName }}
                        </span>
                        <span class="service-table__doc service-table__text">
                            {{ serv.psDocexec }}
                        </span>
                    </div>
                </ng-container>
                <div #sentinel class="sentinel"></div>
            </div>
            <div class="visits__footer" *ngIf="servicesListLength">
                <div class="visits__footer-content">
                    <div
                        class="payments-bottom-loader"
                        *ngIf="loadingServicesList"
                    >
                        <div class="css-spinner"></div>
                        <div class="loader-text">Загружаем список услуг...</div>
                    </div>
                    <span class="visits__footer-text" *ngIf="!loadingServicesList">
                        Записей
                        {{
                            servicesList?.length !== null
                                ? servicesList?.length
                                : 0
                        }}
                        из
                        {{ servicesListLength || 0 }}
                    </span>
                    <div class="visits__footer-progress" *ngIf="!loadingServicesList">
                        <div
                            class="visits__footer-progress-bar"
                            [style.width.%]="
                                servicesListLength > 0
                                    ? ((servicesList || []).length /
                                          servicesListLength) *
                                      100
                                    : 0
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
